export default [{
        header: 'Panel',
    },
    {
        title: 'Management',
        route: 'management',
        icon: 'HomeIcon',
    },
    {
        title: 'Languages',
        route: 'languages',
        icon: 'GlobeIcon',
    },
    {
        title: 'Translations',
        route: 'translations',
        icon: 'FileTextIcon',
    },
    {
        title: 'Devices',
        route: 'devices',
        icon: 'TabletIcon',
    },
    {
        title: 'Users',
        route: 'users',
        icon: 'UserIcon',
    },
    {
        title: 'Airports',
        route: 'airports',
        icon: 'MapPinIcon',
    },
    {
        title: 'Airport Products',
        route: 'airport-products',
        icon: 'ShoppingCartIcon',
        action: 'airport-products',
        subject: 'all'
    },
    {
        title: 'Products',
        route: 'products',
        icon: 'ShoppingCartIcon',
    },
    {
        title: 'Questions',
        route: 'questions',
        icon: 'HelpCircleIcon',
    },
    {
        title: 'ProductQuestions',
        route: 'products-question',
        icon: 'GitPullRequestIcon',
    },
    {
        title: 'AnalysisResults',
        route: 'analysis-results',
        icon: 'PieChartIcon',
    },

]